import PropTypes from 'prop-types'
import React from 'react'
import { getAdThumbnailUrl } from 'SRC/modules/ads/shared/functions'
import { Image } from '../'

export const Images = ({ ad, onClick, length }) => {
  if (!ad) return null

  const main = ad.media ? ad.media.find(m => m.main) : null
  const img = getAdThumbnailUrl({ image: main, size: '600x450' })

  return (
    <div className='oglasi-imgs' onClick={(e) => onClick(0, e)}>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <Image className='oglasi-item-tekst-img' img={img} title={ad.titleCompiled} />

      <div className='ukupno-slika'>
        <p>{length}</p>
        <i className='ico-tab-fotografije ico' />
      </div>

      {ad.status === 'Sold' ? <div className='sold' /> : null}
    </div>
  )
}

Images.propTypes = {
  ad: PropTypes.object,
  onClick: PropTypes.func,
  length: PropTypes.number
}
